module.exports = __webpack_public_path__ + "img/unmute.b3a5a8bf.svg";